import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon as SemanticIcon } from 'semantic-ui-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getLibraryFromIconName, getIconClassFromIconName, iconLibrary } from './Icon.utils';
import { initializeFontAwesomeLibrary } from '../../../../utils/icons';
var propTypes = {
  iconName: PropTypes.string.isRequired,
  className: PropTypes.string
};
var defaultProps = {
  className: ''
};
var initialized = false;
export default function Icon(_ref) {
  var iconName = _ref.iconName,
    className = _ref.className;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    fontAwesomeInitialized = _useState2[0],
    setFontAwesomeInitialized = _useState2[1];
  useEffect(function () {
    if (!initialized) {
      initializeFontAwesomeLibrary();
      initialized = true;
    }
    setTimeout(function () {
      return setFontAwesomeInitialized(true);
    }, 500);
  }, []);
  if (!fontAwesomeInitialized) {
    return null;
  }
  var library = getLibraryFromIconName(iconName);
  var iconClasses = getIconClassFromIconName(iconName);
  var iconComponent = library === iconLibrary.SemanticUI ? /*#__PURE__*/React.createElement(SemanticIcon, {
    className: className,
    name: iconName
  }) : /*#__PURE__*/React.createElement(SemanticIcon, {
    className: className
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: _toConsumableArray(iconClasses)
  }));
  return iconComponent;
}
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;